export class EnagementPaths {
    public static readonly EngagePath: string = '/Engage/:productName';
}